import '../css/Tabs.css';
import { ReactNode, useEffect, useState } from 'react';

// This Component is used by Home, Profile, Public Profile, and CalendarEventModal components
// The purpose of this component is provide an interface for users to acces muliple Components in one place

interface TabsProps {
  page: {
    tabs: string[];
    content: ReactNode[];
    modal: boolean;
  };
}

export const Tabs: React.FC<TabsProps> = ({ page }) => {
  // page is an Object that provides the Data necessary to render the Tabs
  // tabs is an Array of strings that are used to Identify the content their tab holds
  // content is an Array of Components to be rendered when a user changes Tabs
  // modal is a Boolean value that prevents pushing Tab State to History
  // modal is currently used in the CalendarEventModal, it solved a bug that
  // rendered the incorrect activeTab

  const [activeTab, setActiveTab] = useState<number>(1);
  // activeTab State is used to switch between Tabs

  const changeActiveTab = (id: number) => {
    setActiveTab(id);
    !page.modal && history.pushState({ ...history.state, activeTabStatus: id }, '');
    // history.pushState is used to render the Calendar Tab when
    // Navigating from an Event Flyer back to a Profile
  };

  useEffect(() => {
    if (!page.modal && history.state?.activeTabStatus) {
      setActiveTab(history.state?.activeTabStatus);
    }
  }, []);
  // useEffect(() => {
  //   if (location.pathname === '/profile' && history.state?.activeTabStatus) {
  //     !page.modal && setActiveTab(history.state?.activeTabStatus);
  //   }
  // }, []);

  return (
    <div className="tabs-container">
      <div className="tabs-row">
        {page.tabs.map((tab, i) => {
          return (
            <div
              key={tab + i}
              className={activeTab === i + 1 ? 'tabs active-tab' : 'tabs'}
              onClick={() => changeActiveTab(i + 1)}
            >
              {tab}
            </div>
          );
        })}
      </div>
      <div className="tabs-content">
        {page.content.map((media, i) => {
          if (activeTab === i + 1) {
            return (
              <div key={i} id="active-tab-content" className={'display-content active-content'}>
                {media}
              </div>
            );
          } else return null;
        })}
      </div>
    </div>
  );
};
